'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Button } from '~/components/Button';
import { Dialog, DialogContent, DialogHeader } from '~/components/Dialog';
import styles from './MergeCreditsDialog.module.css';
interface MergeCreditsDialogProps {
  readonly isOpen: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly onConfirm: () => void;
  readonly isLoading: boolean;
  readonly expiryDate: string;
}
export function MergeCreditsDialog(t0) {
  const $ = _c(32);
  const {
    isOpen,
    onOpenChange,
    onConfirm,
    isLoading,
    expiryDate
  } = t0;
  const t = useTranslations("account");
  let t1;
  if ($[0] !== t) {
    t1 = t("credit_merge_title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <DialogHeader variant="notification" showCloseButton={false}>{t1}</DialogHeader>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== expiryDate || $[5] !== t) {
    t3 = t("credit_merge_warning", {
      date: expiryDate
    });
    $[4] = expiryDate;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <DialogContent className={styles.content}><p className={styles.message}>{t3}</p></DialogContent>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== onOpenChange) {
    t5 = () => onOpenChange(false);
    $[9] = onOpenChange;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("credit_merge_cancel");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isLoading || $[14] !== t5 || $[15] !== t6) {
    t7 = <Button variant="secondary" onClick={t5} isDisabled={isLoading}>{t6}</Button>;
    $[13] = isLoading;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("credit_merge_confirm");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== isLoading || $[20] !== onConfirm || $[21] !== t8) {
    t9 = <Button onClick={onConfirm} isLoading={isLoading} data-test-id="merge-confirm-button">{t8}</Button>;
    $[19] = isLoading;
    $[20] = onConfirm;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t7 || $[24] !== t9) {
    t10 = <div className={styles.footer}>{t7}{t9}</div>;
    $[23] = t7;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== isOpen || $[27] !== onOpenChange || $[28] !== t10 || $[29] !== t2 || $[30] !== t4) {
    t11 = <Dialog isOpen={isOpen} onOpenChange={onOpenChange} variant="popup">{t2}{t4}{t10}</Dialog>;
    $[26] = isOpen;
    $[27] = onOpenChange;
    $[28] = t10;
    $[29] = t2;
    $[30] = t4;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}